module.exports = __webpack_public_path__ + "img/eppela.29db7ac8.png";